<ng-container>
    <div class="bg-white overflow-hidden shadow">
        <div class="">
            <div class="border-b border-b-gray-300 zuper-dialog-header" *ngIf="!standalone">
                <div class="flex justify-between">
                    <h6 mat-dialog-title class="font-semibold primary-font">{{"maps.picker.title" | translate}}</h6>
                </div>
                <div class="flex items-center ml-auto">
                    <span 
                        (click)="closeDialog()"
                        mat-dialog-close
                        class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
                        <em class="ti ti-x text-xl font-bold"></em>
                    </span>
                </div>
            </div>
            <div class="map-picker-container zuper-scrollbar relative">
                <div class="flex absolute">
                    <mat-form-field appearance="fill" class="flex-shrink-0 z-10 ml-2 mt-2 w-32 map-picker-options-dropdown inline-flex items-center text-base font-medium text-center text-gray-900">
                        <mat-select [(ngModel)]="type" (ngModelChange)="typeChanged()" [panelClass]="['min-w-44']">
                          <mat-option value="" [disabled]="true">{{'text.choose_option' | translate}}</mat-option>
                          <mat-option [value]="'ADDRESS'"> {{ "address.text" | translate}} </mat-option>
                          <mat-option [value]="'GEOCODE'"> {{"maps.picker.dropdown.geo_cordinates" | translate}} </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="relative w-full mt-2 z-10 mr-2">
                        <input 
                            *ngIf="type === 'ADDRESS'"
                            type="search"
                            id="search-location" 
                            class="block p-2.5 w-96 z-20 text-base text-gray-900 bg-white rounded-r-lg  border border-gray-300 border-l-0" 
                            placeholder='{{"maps.picker.placeholder.search_address" | translate}}'
                            [canTruncate]="true"
                            googleMapsAutocomplete
                            (autocompleteSelected)="onAutocompleteSelected($event)"
                        >
                        <input 
                            *ngIf="type === 'GEOCODE'"
                            type="search" 
                            id="search-location" 
                            class="block p-2.5 w-96 z-20 text-base text-gray-900 bg-white rounded-r-lg  border border-gray-300 border-l-0" 
                            placeholder='{{"maps.picker.placeholder.search_geocode" | translate}}'
                            [(ngModel)]="geoCordinates"
                            (keyup)="geocodeChange($event)"
                            (paste)="geocodeChange($event)"
                        >
                    </div>
                </div>
                <div id="map-body" class="w-full"></div>
            </div>
            <div class="flex justify-end border-gray-300 border-t zuper-dialog-footer" *ngIf="!standalone">
                <button 
                    type="button" 
                    mat-dialog-close 
                    (click)="closeDialog()"
                    class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2"
                    >{{"close.text" | translate}}</button>
                <button 
                    type="click"
                    (click)="useAddress()" 
                    class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none"
                    >{{"maps.picker.submit.label" | translate}}</button>
            </div>
        </div>
    </div>
</ng-container>
